<template>
  <v-menu
    close-delay="300"
    nudge-right="19"
    nudge-top="41"
    offset-x
    offset-y
    open-delay="200"
    open-on-hover
    :close-on-content-click="closeOnContentClick"
    :content-class="`menu-wrapper ${padding ? 'menu-padding' : ''}`"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        small
        :class="buttonClass"
        :disabled="disabled"
        @click="handleClick"
      >
        <v-icon :size="size">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <slot />
  </v-menu>
</template>

<script>
export default {
  name: 'ImageMenu',
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    closeOnContentClick: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  min-width: 150px!important;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: white;
  border-radius: 6px;
  border: 1px solid var(--v-blue-lighten-2);
  box-shadow: 0px 5px 5px rgba(var(--v-primary-base-rgb), 0.1),
              0px 9px 10px rgba(var(--v-primary-base-rgb), 0.07),
              0px 5px 14px rgba(var(--v-primary-base-rgb), 0.06);
  color: var(--v-secondary-base);
}

.menu-padding {
  padding-bottom: 12px;
  padding: 8px 15px;
}
</style>
